import React from 'react';
import './UnderMaintenance.css';

const UnderMaintenance = () => {
  return (
    <main className="maintenance-page">
      <section className="maintenance-panel" aria-labelledby="maintenance-title">
        <p className="maintenance-kicker">Veloura</p>
        <h1 id="maintenance-title">Under Maintenance</h1>
        <p>
          We are making updates right now. Please check back soon.
        </p>
        <div className="maintenance-gif-frame">
          <iframe
            title="Under maintenance animation"
            src="https://tenor.com/embed/10659136198576665222"
            allowFullScreen
          />
        </div>
        <a
          className="maintenance-link"
          href="https://gtaw.link/veloura"
          target="_blank"
          rel="noopener noreferrer"
        >
          Veloura Portal
        </a>
      </section>
    </main>
  );
};

export default UnderMaintenance;
